import { render, staticRenderFns } from "./SpeacialStudent.vue?vue&type=template&id=7e9ce27a"
import script from "./SpeacialStudent.vue?vue&type=script&lang=js"
export * from "./SpeacialStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports